import { mark } from 'regenerator-runtime';
import icons from 'url:../../img/sprite.svg';

export default class View {
  _data;
  _popupElement = document.querySelector('.popup__container');
  _overlay;
  _popup;
  _btnClose;

  render(data, render = true, popup = false, renderPopup = false) {
    if (!data || (Array.isArray(data) && data.length === 0))
      return this.renderError();
    this._data = data;
    const markup = this._generateMarkup();

    if (!render) return markup;
    // this._clear();

    if (!popup) {
      this._clear('parent');
      this._parentElement.insertAdjacentHTML('afterbegin', markup);
    }
    if (popup && !renderPopup) {
      this._clear('popup');
      this._popupElement.insertAdjacentHTML('afterbegin', markup);
      this._togglePopup();
    }

    if (popup && renderPopup) {
      const html = this._addToPopup(markup);

      this._clear('popup');
      this._popupElement.insertAdjacentHTML('afterbegin', html);
      this._togglePopup();
    }
  }

  _clear(el) {
    if (el === 'popup') this._popupElement.innerHTML = '';
    if (el === 'parent') this._parentElement.innerHTML = '';

    if (!el) {
      this._parentElement.innerHTML = '';
      this._popupElement.innerHTML = '';
    }
  }

  _addToPopup(html) {
    return `
      <div class="overlay hidden"></div>
      <div class="popup hidden">
        <button class="btn--close-modal">&times;</button>
        ${html}
      </div>     `;
  }

  renderSpinner(parent) {
    const markup = `
      <div class="spinner">
        <svg>
          <use xlink:href="${icons}#icon-spinner"></use>
        </svg>
      </div> 
    `;
    this._clear(parent);
    if (parent === 'popup')
      this._popupElement.insertAdjacentHTML('afterbegin', markup);
    if (!parent) this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  renderError(message = this._errorMessage) {
    const html = `
            <div class="error">
            <div>
              <svg>
                <use href="${icons}#icon-times-circle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>
    `;
    const markup = this._addToPopup(html);

    this._clear('popup');
    this._popupElement.insertAdjacentHTML('afterbegin', markup);
    this._togglePopup();
  }

  renderMessage(message = this._message) {
    const html = `
            <div class="message">
              <div>
                <svg>
                  <use href="${icons}#icon-check-circle"></use>
                </svg>
              </div>
              <p>${message}</p>
            </div>
    `;
    const markup = this._addToPopup(html);

    this._clear('popup');

    this._popupElement.insertAdjacentHTML('afterbegin', markup);

    this._togglePopup();
  }

  closePopup() {
    this._popup.classList.add('hidden');
    this._overlay.classList.add('hidden');
  }

  _togglePopup() {
    this._popup = document.querySelector('.popup');
    this._overlay = document.querySelector('.overlay');
    this._btnClose = document.querySelector('.btn--close-modal');
    this._popup.classList.remove('hidden');
    this._overlay.classList.remove('hidden');

    [this._btnClose, this._overlay, window].forEach(el => {
      if (el !== window) {
        el.addEventListener('click', () => {
          this.closePopup();
        });
      }
      if (el === window) {
        window.addEventListener('keydown', e => {
          if (e.key === 'Escape') {
            this.closePopup();
          }
        });
      }
    });
  }
}
